import styled from 'styled-components';
import { Upload } from 'antd';

export const HeaderImage = styled.div<{ src: string; rounded: boolean }>`
  width: 100%;
  height: 100%;
  background-image: ${({ src }) => `url(${src})`};
  background-position: center center;
  background-size: cover;
  position: relative;
  border-radius: ${({ rounded }) => (rounded ? '50%' : 'unset')};
`;

export const HeaderImagePreview = styled.div<{ aspectRatio?: number }>`
  position: relative;
  height: 0;
  padding-bottom: ${({ aspectRatio = 0.357 }) => (1 / aspectRatio) * 100}%;

  & > ${HeaderImage} {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

export const HeaderImagePreviewContainer = styled.div<{ rounded: boolean }>`
  border: 1px solid #ddd;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: ${({ rounded }) => (rounded ? '50%' : 'unset')};
`;

export const UploadStyled = styled(Upload)`
  position: relative;
  .ant-upload-list {
    display: none;
  }
`;

export const Label = styled.div`
  margin: 0;
  padding: 0 0 8px;
  line-height: 1.5715;
  white-space: initial;
  text-align: left;
`;

export const ImageUploadContainer = styled.div``;

export const ButtonLabelContainer = styled.span`
  position: absolute;
  white-space: nowrap;
  bottom: -3px;
`;
